import {createSelector} from 'reselect';
import {uniportalSelector} from 'modules/rootSelectors';

export const apiStateSelector = createSelector(uniportalSelector, uniportal => uniportal.api || {});

export const apiCallInProgressSelector = createSelector(apiStateSelector, api => api.callInProgress || false);